import moment from 'moment';
import { FILTER_BY, GRANULARITY } from '../../CustomReport/consts';
import { keyBy, get } from 'lodash';

export const ACTIVITY_TYPES = {
  BRANCHES: 'branches',
  PRS: 'pull_requests',
  RELEASES: 'releases',
  UNKNOWN: undefined
};

export const mapActivityTypeToEntityName = {
  [ACTIVITY_TYPES.BRANCHES]: {
    single: 'Branch',
    plural: 'Branches'
  },
  [ACTIVITY_TYPES.PRS]: {
    single: 'PR',
    plural: 'PRs'
  },
  [ACTIVITY_TYPES.RELEASES]: {
    single: 'Release',
    plural: 'Releases'
  }
};

export const getEntityNameByActivityTypeAndTotal = (activityType, total) => {
  const isPlural = total > 1;
  return mapActivityTypeToEntityName[activityType]?.[
    isPlural ? 'plural' : 'single'
  ];
};

export const getGranularityByPeriod = ({ before, after }) => {
  const diff = moment(before).diff(moment(after), 'days') + 1;

  return diff > 90
    ? GRANULARITY.MONTHS
    : diff > 27
    ? GRANULARITY.WEEKS
    : GRANULARITY.DAYS;
};

export const parseMetricsFiltersToMetricsInspection = (
  filters,
  metricName,
  isMultiCriteriaFiltering
) => {
  const {
    globallySelectedTeams,
    selectedRepo = [],
    selectedContributor,
    selectedService = [],
    teamId,
    selectedLabels,
    filterType
  } = filters;

  const getRelevantTeam = () => {
    const teamsById = get(globallySelectedTeams, '[0].id')
      ? keyBy(globallySelectedTeams, 'id')
      : {};
    return teamsById[teamId || globallySelectedTeams[0]?.id] || null;
  };

  const activityType = metricName?.includes('branch.')
    ? ACTIVITY_TYPES.BRANCHES
    : metricName?.includes('pr.')
    ? ACTIVITY_TYPES.PRS
    : ACTIVITY_TYPES.UNKNOWN;

  const getFilteredValue = (filterTypeCondition, selectedValue) => {
    return isMultiCriteriaFiltering
      ? selectedValue
      : filterTypeCondition && selectedValue;
  };

  const repo = getFilteredValue(filterType === FILTER_BY.REPO, selectedRepo);
  const contributor = getFilteredValue(
    filterType === FILTER_BY.PEOPLE,
    selectedContributor
  );
  const service = getFilteredValue(
    filterType === FILTER_BY.SERVICE,
    selectedService
  );
  const label = getFilteredValue(
    filterType === FILTER_BY.LABEL,
    get(selectedLabels, '[0]')
  );

  return {
    activityType,
    filterType,
    repo,
    contributor,
    service,
    team: getRelevantTeam(globallySelectedTeams, teamId),
    label
  };
};

export const validateMetricsInspectionProps = (
  filters,
  allowMulti = false,
  isMultiCriteriaFiltering = false
) => {
  if (isMultiCriteriaFiltering) {
    return (
      allowMulti ||
      (filters.globallySelectedTeams?.length <= 1 &&
        filters.selectedLabels?.length <= 1)
    );
  }

  switch (filters.filterType) {
    case FILTER_BY.PEOPLE:
      return allowMulti || filters.globallySelectedTeams?.length <= 1;
    case FILTER_BY.LABEL:
      return allowMulti || filters.selectedLabels?.length <= 1;
    // only single entity can be selected in dropdown
    case FILTER_BY.SERVICE:
    case FILTER_BY.REPO:
      return true;
  }
};
